import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_c96ba5732c80552afcd916fa9aa22c41/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import logger from 'common/utils/udp-logger';
import apiConfig from 'portal-common/config/apiConfig';
import { NAMESPACE } from 'portal-common/constants/requestConstants';
import { api } from 'portal-common/http';
import request from 'portal-common/service/fetch';
import { GET_USER_INFO_URL } from '../common/constants';
import { getUserRemoteIP, setCors } from '../common/util';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// 从cookie中获取qcloud_from用于上报
var getRealQcloudFromByCookie = function(request1) {
    var ref;
    var qcloudFrom = (request1 === null || request1 === void 0 ? void 0 : (ref = request1.cookies) === null || ref === void 0 ? void 0 : ref.qcloud_from) || '';
    var realQcloudFrom = '';
    if (qcloudFrom) {
        var ref1;
        ref1 = _slicedToArray(String(qcloudFrom).split('-'), 1), qcloudFrom = ref1[0], ref1;
        if (/^[0-9a-zA-Z.]{1,100}$/.test(qcloudFrom)) {
            realQcloudFrom = qcloudFrom;
        }
    }
    return realQcloudFrom;
};
var packReqData = function(interfaceName, para) {
    return {
        version: 1,
        componentName: 'qcmain',
        eventId: ~~(Math.random() * 999999999) + 100000000,
        timestamp: Date.now(),
        user: 'auto',
        interface: {
            interfaceName: interfaceName,
            para: para
        }
    };
};
// 获取用户信息，带校验登录态作用
export var getUserInfo = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req, res) {
        var cookies, cip, suin, skey, paramData, paramBody, result, returnCode, startOwnerUin, uinValue, ownerUin, uin;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cookies = req.cookies;
                    cip = getUserRemoteIP(req);
                    suin = '';
                    skey = '';
                    if (cookies && cookies.uin && cookies.skey) {
                        suin = cookies.uin;
                        skey = cookies.skey;
                    }
                    setCors(req, res);
                    paramData = {
                        uin: suin,
                        skey: skey,
                        cip: cip,
                        domain_id: 0,
                        need_nick: 1,
                        verifyBillingStatus: false
                    };
                    paramBody = packReqData('active.ptlogin.verify', paramData);
                    _ctx.next = 10;
                    return request.post("".concat(apiConfig.mcproxyApi.url), _objectSpread({}, paramBody), {
                        headers: {
                            requestid: req.headers['x-request-id'] || ''
                        }
                    });
                case 10:
                    result = _ctx.sent;
                    returnCode = result.returnCode;
                    if (returnCode === 0) {
                        startOwnerUin = cookies.ownerUin || '';
                        uinValue = cookies.uin || '';
                        ownerUin = startOwnerUin;
                        uin = uinValue;
                        if (uinValue.toLocaleLowerCase().startsWith('o')) {
                            uin = uinValue.slice(1);
                        }
                        if (ownerUin) {
                            if (ownerUin.toLocaleLowerCase().startsWith('o')) {
                                ownerUin = ownerUin.slice(1);
                            }
                            if (ownerUin.toLocaleLowerCase().endsWith('g')) {
                                ownerUin = ownerUin.slice(0, -1);
                            }
                        }
                        result = {
                            code: 0,
                            data: {
                                uin: uin,
                                owner_uin: ownerUin
                            }
                        };
                    } else {
                        result = {
                            code: 600001,
                            data: {},
                            msg: 'check login error'
                        };
                    }
                    return _ctx.abrupt("return", result);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    // const result = await api.call(GET_USER_INFO_URL, {
    //   method: 'get',
    //   params: {
    //     uin: req?.cookies?.uin || '',
    //     skey: req?.cookies?.skey || '',
    //   },
    //   headerconfig: {
    //     Cookie: `uin=${req?.cookies?.uin || ''};skey=${req?.cookies?.skey || ''}`,
    //   },
    // });
    // logger.info('discountApi-getUserInfo', { result, params: { uin: req?.cookies?.uin, skey: req?.cookies?.skey } });
    // return result;
    }));
    return function getUserInfo(req, res) {
        return _ref.apply(this, arguments);
    };
}();
// 获取用户信息，带校验登录态作用
export var getLoginInfo = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req) {
        var ref, ref2, ref3, ref4, ref5, ref6, result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return api.call(GET_USER_INFO_URL, {
                        method: 'get',
                        params: {
                            uin: (req === null || req === void 0 ? void 0 : (ref = req.cookies) === null || ref === void 0 ? void 0 : ref.uin) || '',
                            skey: (req === null || req === void 0 ? void 0 : (ref2 = req.cookies) === null || ref2 === void 0 ? void 0 : ref2.skey) || ''
                        },
                        headerconfig: {
                            Cookie: "uin=".concat((req === null || req === void 0 ? void 0 : (ref3 = req.cookies) === null || ref3 === void 0 ? void 0 : ref3.uin) || '', ";skey=").concat((req === null || req === void 0 ? void 0 : (ref4 = req.cookies) === null || ref4 === void 0 ? void 0 : ref4.skey) || '')
                        }
                    });
                case 3:
                    result = _ctx.sent;
                    logger.info('discountApi-getLoginInfo', {
                        result: result,
                        params: {
                            uin: req === null || req === void 0 ? void 0 : (ref5 = req.cookies) === null || ref5 === void 0 ? void 0 : ref5.uin,
                            skey: req === null || req === void 0 ? void 0 : (ref6 = req.cookies) === null || ref6 === void 0 ? void 0 : ref6.skey
                        }
                    });
                    return _ctx.abrupt("return", result);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLoginInfo(req) {
        return _ref.apply(this, arguments);
    };
}();
/** *
 *@description 下单
 *@param uin
 *@param orderInfo
 * */ export var createEventOrder = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req, res, RenderAjax) {
        var ref, code, _data, data, _uin, uin, tmp, owenUin, ref7, billParams, bill, _data1, isOpen, account, data1, ip, params, referer, originate, result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getUserInfo(req, res);
                case 2:
                    ref = _ctx.sent;
                    code = ref.code;
                    _data = ref.data;
                    data = _data === void 0 ? {} : _data;
                    _uin = data.uin, uin = _uin === void 0 ? '' : _uin, tmp = data.owner_uin, owenUin = tmp === void 0 ? '' : tmp;
                    if (!(code === 0 && owenUin)) {
                        _ctx.next = 39;
                        break;
                    }
                    ;
                    billParams = req.body;
                    billParams.uin = owenUin;
                    _ctx.next = 13;
                    return RenderAjax.getBillAccountIsOpenByUin(billParams);
                case 13:
                    bill = _ctx.sent;
                    logger.info('discountApi-GetBillAccountIsOpenByUin', {
                        billParams: billParams,
                        billresult: bill
                    });
                    _data1 = bill.data, isOpen = _data1.is_open;
                    if (isOpen) {
                        _ctx.next = 25;
                        break;
                    }
                    billParams.page = 1;
                    billParams.page_size = 10;
                    _ctx.next = 21;
                    return RenderAjax.getBillAccountPaymentMethod(billParams);
                case 21:
                    account = _ctx.sent;
                    logger.info('discountApi-GetBillAccountPaymentMethod', {
                        billParams: billParams,
                        paymentMethod: account
                    });
                    data1 = account.data;
                    return _ctx.abrupt("return", {
                        code: -1001,
                        data: data1,
                        msg: '获取绑卡信息'
                    });
                case 25:
                    ip = getUserRemoteIP(req);
                    params = req.body;
                    params.uin = uin;
                    params.ownerUin = "".concat(owenUin);
                    params.skey = (req === null || req === void 0 ? void 0 : (ref7 = req.cookies) === null || ref7 === void 0 ? void 0 : ref7.skey) || '';
                    params.system = {
                        ip: ip
                    };
                    referer = req.headers.referer || '';
                    originate = getRealQcloudFromByCookie(req);
                    params.additionNoSign = {
                        originate: originate,
                        extparam: {
                            referer: referer
                        }
                    };
                    _ctx.next = 36;
                    return RenderAjax.createEventOrder(params);
                case 36:
                    result = _ctx.sent;
                    logger.info('discountApi-createEventOrder', {
                        params: params,
                        result: result
                    });
                    return _ctx.abrupt("return", result);
                case 39:
                    return _ctx.abrupt("return", {
                        code: -1000,
                        data: data,
                        msg: '获取用户信息出错'
                    });
                case 40:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createEventOrder(req, res, RenderAjax) {
        return _ref.apply(this, arguments);
    };
}();
export var queryEventCommodityPrice = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
        var API_PREFIX, result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    API_PREFIX = "/".concat(NAMESPACE.QCINTL_API);
                    _ctx.next = 3;
                    return api.fetchMidProxy("".concat(API_PREFIX, "/portal-operation-event/queryEventCommodityPrice"), {
                        body: params,
                        method: 'post'
                    });
                case 3:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function queryEventCommodityPrice(params) {
        return _ref.apply(this, arguments);
    };
}();
export var queryBluePrints = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
        var API_PREFIX, result, code, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    API_PREFIX = "/".concat(NAMESPACE.QCINTL_API);
                    _ctx.next = 3;
                    return api.fetchMidProxy("".concat(API_PREFIX, "/portal-operation-event/queryBluePrints"), {
                        body: params,
                        method: 'post'
                    });
                case 3:
                    result = _ctx.sent;
                    code = result.code, data = result.data;
                    if (!(code === 0)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", result);
                case 7:
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function queryBluePrints(params) {
        return _ref.apply(this, arguments);
    };
}();
